import { useQuery } from "@tanstack/react-query";
import { fetchData } from "./UseStudentGetApi";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";

export const useTrainerCourses = (id) => {
  return useQuery({
    queryKey: ["trainer-courses-events", id],
    queryFn: () => fetchDataNode(`trainer-courses-events/${id}`),
  });
};

export const useTrainerCourseCount = () => {
  return useQuery({
    queryKey: ["trainer-course-count"],
    queryFn: () => fetchDataNode(`trainer-course-count`),
  });
};

export const useViewStudentAtd = (filters) => {
  return useQuery({
    queryKey: ["view_student_atd", filters],
    queryFn: () => fetchDataNode(`attendance/user`, filters),
    enabled: filters && Object.keys(filters).length > 0,
  });
};

export const useTrainerSessions = (filters) => {
  return useQuery({
    queryKey: ["/trainer/schedule", filters],
    queryFn: () => fetchDataNode(`trainer/schedule`, filters),
  });
};

export const useApartmentUnderTrainer = (filters) => {
  return useQuery({
    queryKey: ["trainer/apartments", filters],
    queryFn: () => fetchDataNode(`trainer/apartments`, filters),
  });
};
export const useTrainerStudentEnList = (filters) => {
  return useQuery({
    queryKey: ["my/student-leads", filters],
    queryFn: () => fetchDataNode(`my/student-leads`, filters),
  });
};

// export const useTrainerMeeting = (id) => {
//   return useQuery({
//     queryKey: [`zoom-meeting/start-url`],
//     queryFn: () => fetchDataNode(`zoom-meeting/${id}/start-url`),
//   });
// };

export const useTrainerMeeting = (filter) => {
  return useQuery({
    queryKey: [`zoom/start-url/trainer`,filter],
    queryFn: () => fetchDataNode(`zoom/start-url`,filter),
  });
};





export const useTrainerOnlineCourse = (filters) => {
  return useQuery({
    queryKey: ["trainer/online-batches", filters],
    queryFn: () => fetchDataNode(`trainer/online-batches`, filters),
  });
};


export const useTrainerOnlineCurrentCourses = (filters) => {
  return useQuery({
    queryKey: ["trainer/currentday-online-course",],
    queryFn: () => fetchDataNode(`trainer/currentday-online-course`),
  });
};

export const useTrainerOfflineCurrentCourses = (filters) => {
  return useQuery({
    queryKey: ["trainer/currentday-offline-course"],
    queryFn: () => fetchDataNode(`trainer/currentday-offline-courses`),
  });
};


export const useTrainerRating = (trainerId) => {
  return useQuery({
    queryKey: ["ratings/trainer", trainerId],
    queryFn: () => fetchDataNode(`ratings/trainer/${trainerId}`),
    enabled: !!trainerId,
  });
};